<template>
  <el-dialog
    title="新建项目"
    :visible.sync="currentValue"
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="main-add-project"
    @closed="resetForm"
    width="590px">
    <div class="wrap-form" v-loading="loading">
      <el-form class="my-form" ref="form" :model="form" :rules="rules" size="large" label-position="top">
        <el-form-item label="项目名称" prop="title">
          <el-input type="text" placeholder="请输入项目名称" v-model="form.title" clearable class="has-color">
            <template slot="prefix">
              <ColorControl @change="colorChange"></ColorControl>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="项目成员" prop="member">
          <el-popover placement="bottom" trigger="click" v-model="memberVisible">
            <div slot="reference">
              <wf-button plain icon="icon iconfont iconicon_enlarge" auto size="large">添加</wf-button>
              <!-- <div class="add-member-box">
                <i class="icon iconfont iconicon_enlarge add"></i>
                <span>添加</span>
              </div> -->
            </div>
            <!-- <ParticipantList @close="memberVisible = false" v-model="form.member" @confirm="slecetVaule" :taskMemberlist="options" :lockUid="[]"></ParticipantList> -->

            <ParticipantList v-if="memberVisible"  @confirm="slecetVaule" @close="memberVisible = false" :membersUidArr="form.member" :showUser="true"></ParticipantList>
          </el-popover>
        </el-form-item>
        <div class="team-box">
          <div class="member-item" v-for="item in memberList" :key="item.userId">
            <div class="member-avatar" style="margin-left:6px;">
              <Myavatar width="28px" height="28px" :imgUrl="item.user_avatar" :userName="item.realname">
                <toolTip :title="item.realname" maxWidth="100px">{{item.realname}}</toolTip>
              </Myavatar>
            </div>
            <div class="member-icon"><i class="icon iconfont iconicon_close1 tableIconHover" @click="removeUser(item)"></i></div>
          </div>
        </div>
        <el-form-item label="项目模板" prop="project_template_id" style="width: 100%;">
          <el-select v-model="form.project_template_id" placeholder="请选择" style="width: 100%;" class="template-select">
            <template #prefix>
              <span v-if="form.project_template_id && form.project_template_id !== -1" class="text-blue-block template-select-prefix" @click.stop="lookTemplate(form.project_template_id)">预览</span>
            </template>
            <el-option
              v-for="item in templateResult"
              :key="item.id"
              :label="item.template_name"
              :value="item.id">
              <div class="template-option">
                <toolTip :title="item.template_name">{{item.template_name}}</toolTip>
                <span class="text-blue-block" @click.stop="lookTemplate(item.id)">预览</span>
              </div>
            </el-option>
            <el-option
              label="自定义项目"
              :value="-1">
              <div class="template-option">
                自定义项目
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联产品项" prop="product_ids" style="width: 100%;"  v-if="queryData.project_depart_id && queryData.project_depart_id === 1">
          <el-cascader :props="props" v-model="form.product_ids"></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <div></div>
      <div class="footer-right">
        <span class="text-btn-active" @click="currentValue = false" style="margin-right: 24px;">取消</span>
        <wf-button type="primary" @click="onSubmit" :disabled="isDisabled" :loading="loading">创建</wf-button>
      </div>
    </span>
    <Dialog v-model="showDialog" :id="showId" v-if="showDialog" @success="previewSuccess"></Dialog>
  </el-dialog>
</template>
<script>
import projectApi from "@/services/api/project/project.js"
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import ParticipantList from '@/components/projectMembersPopover/components/participantList'
import productApi from '@/services/api/product/product'
import ColorControl from '@/components/colorControl'
import Dialog from './previewTemplate'
export default {
  name: "addProject",
  props: ['queryData','value'],
  data() {
    return {
      form: {
        title: "", //项目标题
        member: [],
        background_color: '',
        background_text: '',
        project_template_id: -1,
        product_ids: []
      },
      rules: {
        title: [
          { required: true, trigger: "change", message: "项目标题不能为空" },
          { max: 140, trigger: "change", message: "项目标题不能超过140个字符" }
        ],
        project_depart_id: [{ required: true, trigger: "change", message: "项目团队不能为空" }],
        member: [{ required: true, trigger: "blur", message: "项目成员不能为空" }],
        project_list_id: [{ required: true, trigger: "change", message: "业务线不能为空" }],
        project_template_id: [{ required: true, trigger: "change", message: "项目模板不能为空" }],
        product_ids: [{ required: true, trigger: "blur", message: "关联产品项不能为空" }],
      },
      props: {
        lazy: true,
        multiple: true,
        emitPath: false,
        async lazyLoad(node, resolve) {
          const { level, data } = node
          if (level === 0) {
            let result = await productApi.productSeriesIndex({ page: 1, per_page: 999,  development_status: [10, 30] })
            let treeNodes = result?.data.map(res => {
              return {
                value: res.id,
                label: res.series_name
              }
            })
            resolve(treeNodes)
            return
          } else {
            let result = await productApi.productsIndex({ product_series_id: data.value, page: 1, per_page: 999,  development_status: [10, 30] })
            let treeNodes = result?.data.map(res => {
              return {
                value: res.id,
                label: res.product_name,
                disabled: res.development_status === 40,
                leaf: true,
                lazy: false
              }
            })
            resolve(treeNodes)
          }
        }
      },
      memberList: [],
      defaultArr: [],
      options: [],
      departmentProjectFolderList: [],
      memberVisible: false,
      templateResult: [],
      loading: false,
      showDialog: false,
      showId: ''
    }
  },
  components: {
    ParticipantList,
    ColorControl,
    Dialog
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    isDisabled() {
      return !this.form.title || (this.memberList && this.memberList.length === 0)
    }
  },
  created() {
  },
  mounted() {
    this.getProjectTemplate()
  },
  methods: {
    ...mapActions('project/project', ['addProject', 'editProject',]),
    ...mapActions('department/department', ['getDepartmentUser']),
    async getProjectTemplate() {
      let params = {
        page: 1,
        per_page: 999,
      }
      let result = await projectApi.indexProjectTemplates(params)
      this.templateResult = result.data
    },
    resetForm() {
      this.form.title = "";
      this.form.project_depart_id = null;
      this.form.project_list_id = ""
      this.form.background_color = ''
      this.form.background_text = ''
      this.form.member = [];
      this.memberList = [];
      this.$refs['form'].resetFields();
    },
    onSubmit() {
      // 表单验证
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          let params = {
            ...this.form,
            ...this.queryData
          }
          try {
            await this.addProject(params)
            this.$emit("success");
            this.resetForm();
            this.currentValue = false
          } catch (error) {
          }
          this.loading = false
        }
      });
    },
    removeUser(itemData) {
      let index = this.memberList.indexOf(itemData);
      let idx = 0
      this.form.member.find((res, index) => {
        idx = index
        return itemData.uid == res[res.length - 1]
      })
      this.memberList.splice(index, 1);
      let arr = JSON.parse(JSON.stringify(this.form.member))
      arr.splice(idx, 1)
      this.form.member = [...arr]
    },
    close() {
      this.$emit("update:visible", false)
    },
    slecetVaule(data, list) {
      this.memberVisible = false
      this.memberList = [...list]
      this.form.member = JSON.parse(JSON.stringify(data))
      console.log('-----------', data, this.form.member)
    },
    colorChange(val) {
      let {background_color, background_text} = val
      this.form.background_color = background_color
      this.form.background_text = background_text
    },
    lookTemplate(id) {
      this.showId = id
      this.showDialog = true
    },
    previewSuccess(val) {
      this.showDialog = false
      this.$viewerApi({
        images: [val],
      })
    }
  }
};
</script>

<style lang="scss">
.template-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  .tool-tip {
    width: 0;
    flex: 1;
    padding-right: 40px;
  }
  >span {
    color: #2682FF;
    line-height: 1;
    font-size: 14px;
    margin-right: 28px;
  }
}
.main-add-project {
  .template-select {
    .el-input__prefix  {
      right: 32px;
      left: auto !important;
    }
    .el-input__inner {
      padding-left: 15px !important;
    }
    .template-select-prefix {
      color: #2682FF;
      line-height: 1;
    }
  }
  .dialog-footer{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    align-items: center;
  }
  .el-dialog__body{
    color: #0D1F3C;
    padding-top: 12px;
    padding-bottom: 0px;
  }
  .el-dialog__header {
    border-bottom: 1px solid rgba(231,232,237,0.6);
    padding: 0 24px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(231,232,237,0.6);
    padding: 0 24px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-dropdown i{
    font-size: 16px;
  }
  .el-form-item__error {
    // margin-top: -7px;
  }
  .content-box-parent {
    height: 40px;
  }
  .project-select-member {
    overflow: visible;
    flex-shrink: 0;
    .add {
      line-height: 1;
    }
  }
  .submit-box {
    padding: 15px 0;
    display: flex;
    justify-content: flex-start;
  }
  .close-form {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .newPipoe {
    display: flex;
    flex-direction: column;
  }
  .el-form-item {
    margin-bottom: 20px;
    .has-color .el-input__inner {
      padding-left: 70px;
    }
    .color-control {
      border-right: 1px solid rgba(32, 32, 32, 0.16);
      padding-right: 8px;
    }
    .color-control,.color-control .el-dropdown-link, .color-control .el-dropdown, .color-control .el-dropdown-link {
      height: 100%;
    }
    .el-input__prefix {
      left: 8px;
    }
    .el-input__prefix .color-control .el-dropdown {
      .el-dropdown-link img{
        width: 20px;
        height: 20px;
        border-radius: 4px;
      }
    }
  }
  .el-form-item__content {
    line-height: 40px;
  }
  .el-dropdown-link {
    line-height: 40px;
  }
  .iconicon_user_more_task {
    display: flex;
    align-items: center;
  }
  .team-box {
    line-height: 1.3;
  }
  .el-cascader {
    width: 100%;
  }
}
</style>
